[
  {
    "id": "simple-landscape-birthday",
    "name": "Simple Landscape Birthday",
    "orientation": "landscape",
    "categories": [
      "Birthday"
    ],
    "tags": [
      "simple",
      "brand"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SIMPLE-L-001",
    "variants": [
      {
        "id": "simple-landscape-birthday-7x5l",
        "label": "Default",
        "front": {
          "textFontPolicy": "brand",
          "type": "static",
          "preview": {
            "frontUrl": "",
            "thumbUrl": ""
          },
          "background": {
            "type": "theme",
            "key": "accent"
          },
          "logoSlot": {
            "bounds": {
              "x": 0.4,
              "y": 0.05,
              "width": 0.2,
              "height": 0.18
            },
            "objectFit": "contain"
          },
          "textLayers": [
            {
              "id": "headline",
              "label": "Headline",
              "type": "string",
              "defaultValue": "Happy Birthday",
              "maxLength": 80,
              "bounds": {
                "x": 0.06,
                "y": 0.25,
                "width": 0.88,
                "height": 0.65
              },
              "defaultFontSize": 0.16,
              "fontFamily": "theme:fontPrimary",
              "color": "theme:textOnBlock",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ],
          "backdrop": {
            "source": "theme",
            "overlayOpacity": 0.35
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600,
          "logoSlot": {
            "bounds": {
              "x": 0.4,
              "y": 0.02,
              "width": 0.2,
              "height": 0.18
            },
            "objectFit": "contain"
          }
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "simple-landscape-thank-you",
    "name": "Simple Landscape Thank You",
    "orientation": "landscape",
    "categories": [
      "Thank You"
    ],
    "tags": [
      "simple",
      "brand"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SIMPLE-L-002",
    "variants": [
      {
        "id": "simple-landscape-thank-you-7x5l",
        "label": "Default",
        "front": {
          "textFontPolicy": "brand",
          "type": "static",
          "preview": {
            "frontUrl": "",
            "thumbUrl": ""
          },
          "background": {
            "type": "theme",
            "key": "accent"
          },
          "logoSlot": {
            "bounds": {
              "x": 0.4,
              "y": 0.05,
              "width": 0.2,
              "height": 0.18
            },
            "objectFit": "contain"
          },
          "textLayers": [
            {
              "id": "headline",
              "label": "Headline",
              "type": "string",
              "defaultValue": "Thank You",
              "maxLength": 80,
              "bounds": {
                "x": 0.06,
                "y": 0.25,
                "width": 0.88,
                "height": 0.65
              },
              "defaultFontSize": 0.16,
              "fontFamily": "theme:fontPrimary",
              "color": "theme:textOnBlock",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ],
          "backdrop": {
            "source": "theme",
            "overlayOpacity": 0.35
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600,
          "logoSlot": {
            "bounds": {
              "x": 0.4,
              "y": 0.02,
              "width": 0.2,
              "height": 0.18
            },
            "objectFit": "contain"
          }
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "simple-landscape-congrats",
    "name": "Simple Landscape Congratulations",
    "orientation": "landscape",
    "categories": [
      "Congratulations"
    ],
    "tags": [
      "simple",
      "brand"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SIMPLE-L-003",
    "variants": [
      {
        "id": "simple-landscape-congrats-7x5l",
        "label": "Default",
        "front": {
          "textFontPolicy": "brand",
          "type": "static",
          "preview": {
            "frontUrl": "",
            "thumbUrl": ""
          },
          "background": {
            "type": "theme",
            "key": "accent"
          },
          "logoSlot": {
            "bounds": {
              "x": 0.4,
              "y": 0.05,
              "width": 0.2,
              "height": 0.18
            },
            "objectFit": "contain"
          },
          "textLayers": [
            {
              "id": "headline",
              "label": "Headline",
              "type": "string",
              "defaultValue": "Congratulations",
              "maxLength": 80,
              "bounds": {
                "x": 0.06,
                "y": 0.25,
                "width": 0.88,
                "height": 0.65
              },
              "defaultFontSize": 0.16,
              "fontFamily": "theme:fontPrimary",
              "color": "theme:textOnBlock",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ],
          "backdrop": {
            "source": "theme",
            "overlayOpacity": 0.35
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600,
          "logoSlot": {
            "bounds": {
              "x": 0.4,
              "y": 0.02,
              "width": 0.2,
              "height": 0.18
            },
            "objectFit": "contain"
          }
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "simple-landscape-love",
    "name": "Simple Landscape Love",
    "orientation": "landscape",
    "categories": [
      "Love"
    ],
    "tags": [
      "simple",
      "brand"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SIMPLE-L-004",
    "variants": [
      {
        "id": "simple-landscape-love-7x5l",
        "label": "Default",
        "front": {
          "textFontPolicy": "brand",
          "type": "static",
          "preview": {
            "frontUrl": "",
            "thumbUrl": ""
          },
          "background": {
            "type": "theme",
            "key": "accent"
          },
          "logoSlot": {
            "bounds": {
              "x": 0.4,
              "y": 0.05,
              "width": 0.2,
              "height": 0.18
            },
            "objectFit": "contain"
          },
          "textLayers": [
            {
              "id": "headline",
              "label": "Headline",
              "type": "string",
              "defaultValue": "With Love",
              "maxLength": 80,
              "bounds": {
                "x": 0.06,
                "y": 0.25,
                "width": 0.88,
                "height": 0.65
              },
              "defaultFontSize": 0.16,
              "fontFamily": "theme:fontPrimary",
              "color": "theme:textOnBlock",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ],
          "backdrop": {
            "source": "theme",
            "overlayOpacity": 0.35
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600,
          "logoSlot": {
            "bounds": {
              "x": 0.4,
              "y": 0.02,
              "width": 0.2,
              "height": 0.18
            },
            "objectFit": "contain"
          }
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "simple-landscape-get-well",
    "name": "Simple Landscape Get Well",
    "orientation": "landscape",
    "categories": [
      "Get Well"
    ],
    "tags": [
      "simple",
      "brand"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SIMPLE-L-005",
    "variants": [
      {
        "id": "simple-landscape-get-well-7x5l",
        "label": "Default",
        "front": {
          "textFontPolicy": "brand",
          "type": "static",
          "preview": {
            "frontUrl": "",
            "thumbUrl": ""
          },
          "background": {
            "type": "theme",
            "key": "accent"
          },
          "logoSlot": {
            "bounds": {
              "x": 0.4,
              "y": 0.05,
              "width": 0.2,
              "height": 0.18
            },
            "objectFit": "contain"
          },
          "textLayers": [
            {
              "id": "headline",
              "label": "Headline",
              "type": "string",
              "defaultValue": "Get Well Soon",
              "maxLength": 80,
              "bounds": {
                "x": 0.06,
                "y": 0.25,
                "width": 0.88,
                "height": 0.65
              },
              "defaultFontSize": 0.16,
              "fontFamily": "theme:fontPrimary",
              "color": "theme:textOnBlock",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ],
          "backdrop": {
            "source": "theme",
            "overlayOpacity": 0.35
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600,
          "logoSlot": {
            "bounds": {
              "x": 0.4,
              "y": 0.02,
              "width": 0.2,
              "height": 0.18
            },
            "objectFit": "contain"
          }
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "simple-landscape-thinking-of-you",
    "name": "Simple Landscape Thinking of You",
    "orientation": "landscape",
    "categories": [
      "Thinking of You"
    ],
    "tags": [
      "simple",
      "brand"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SIMPLE-L-006",
    "variants": [
      {
        "id": "simple-landscape-thinking-of-you-7x5l",
        "label": "Default",
        "front": {
          "textFontPolicy": "brand",
          "type": "static",
          "preview": {
            "frontUrl": "",
            "thumbUrl": ""
          },
          "background": {
            "type": "theme",
            "key": "accent"
          },
          "logoSlot": {
            "bounds": {
              "x": 0.4,
              "y": 0.05,
              "width": 0.2,
              "height": 0.18
            },
            "objectFit": "contain"
          },
          "textLayers": [
            {
              "id": "headline",
              "label": "Headline",
              "type": "string",
              "defaultValue": "Thinking of You",
              "maxLength": 80,
              "bounds": {
                "x": 0.06,
                "y": 0.25,
                "width": 0.88,
                "height": 0.65
              },
              "defaultFontSize": 0.16,
              "fontFamily": "theme:fontPrimary",
              "color": "theme:textOnBlock",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ],
          "backdrop": {
            "source": "theme",
            "overlayOpacity": 0.35
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [],
          "maxChars": 600,
          "logoSlot": {
            "bounds": {
              "x": 0.4,
              "y": 0.02,
              "width": 0.2,
              "height": 0.18
            },
            "objectFit": "contain"
          }
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  }
]